module.exports = {
   Url: process.env.REACT_APP_BASE_URL || "https://volt-api.foodonreels.com/api",
};
